var React = require('react');

function IconTwitterInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_79_1603)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM20.0544 6H17.6009L13.5581 10.4735L10.0626 6H5L11.049 13.6569L5.31595 20H7.77087L12.1957 15.1057L16.0627 20H21L14.6943 11.9303L20.0544 6ZM18.0993 18.5785H16.7399L7.86506 7.34687H9.32392L18.0993 18.5785Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_79_1603"},React.createElement("rect",{"width":"26","height":"26","fill":"white"})))]);
}

IconTwitterInline.defaultProps = {"viewBox":"0 0 26 26"};

module.exports = IconTwitterInline;

IconTwitterInline.default = IconTwitterInline;
